export default __webpack_public_path__ + "static/media/do-it-together.41324333.svg";